import numeral from 'numeral';
import { CURRENCY_SYMBOL } from './constants';

// ----------------------------------------------------------------------

export function fNumber(number) {
  return numeral(number).format();
}

export function fCurrency(number) {
  const format = number ? numeral(number).format(`${CURRENCY_SYMBOL}0,0.00`) : '';

  return result(format, '.00');
}

export function formatCash(amount) {
  return `${CURRENCY_SYMBOL}${formatPrice(amount)}`;
}

export function fPercent(number) {
  const format = number ? numeral(Number(number) / 100).format('0.0%') : '';

  return result(format, '.0');
}

export function fShortenNumber(number) {
  const format = number ? numeral(number).format('0.00a') : '';

  return result(format, '.00');
}

export function fData(number) {
  const format = number ? numeral(number).format('0.0 b') : '';

  return result(format, '.0');
}

export function formatPrice(amount, decimals = 2) {
  if (amount === null || amount === undefined || amount === "" || isNaN(parseFloat(amount))) return "0";

  const numAmount = typeof amount === "string" ? parseFloat(amount.replace(/,/g, "")) : amount;
  const hasDecimals = numAmount % 1 !== 0;

  return numAmount.toLocaleString("en-GB", {
    minimumFractionDigits: hasDecimals ? decimals : 0,
    maximumFractionDigits: decimals,
  });
}

function result(format, key = '.00') {
  const isInteger = format.includes(key);

  return isInteger ? format.replace(key, '') : format;
}
